import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { pgTable, primaryKey, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { BookCollection } from '../book-collection/book-collection'
import { LibraryHomepageRow } from './library-homepage-row'

export const LibraryHomepageRowToBookCollection = pgTable(
  'library_homepage_row_to_book_collection',
  {
    libraryHomepageRowId: uuid()
      .notNull()
      .references(() => LibraryHomepageRow.id, { onDelete: 'cascade' }),
    bookCollectionId: uuid()
      .notNull()
      .references(() => BookCollection.id, { onDelete: 'cascade' }),
  },
  (table) => [
    primaryKey({
      columns: [table.libraryHomepageRowId, table.bookCollectionId],
      name: 'library_homepage_row_to_book_collection_pk',
    }),
  ],
)

export const libraryHomepageRowToBookCollectionRelations = relations(LibraryHomepageRowToBookCollection, ({ one }) => ({
  libraryHomepageRow: one(LibraryHomepageRow, {
    fields: [LibraryHomepageRowToBookCollection.libraryHomepageRowId],
    references: [LibraryHomepageRow.id],
  }),
  bookCollection: one(BookCollection, {
    fields: [LibraryHomepageRowToBookCollection.bookCollectionId],
    references: [BookCollection.id],
  }),
}))

export const InsertLibraryHomepageRowToBookCollectionSchema = createInsertSchema(LibraryHomepageRowToBookCollection)
export const UpdateLibraryHomepageRowToBookCollectionSchema = createUpdateSchema(
  LibraryHomepageRowToBookCollection,
).partial()
export const SelectLibraryHomepageRowToBookCollectionSchema = createSelectSchema(LibraryHomepageRowToBookCollection)

export type InsertLibraryHomepageRowToBookCollection = typeof LibraryHomepageRowToBookCollection.$inferInsert
export type UpdateLibraryHomepageRowToBookCollection = z.infer<typeof UpdateLibraryHomepageRowToBookCollectionSchema>
export type SelectLibraryHomepageRowToBookCollection = typeof LibraryHomepageRowToBookCollection.$inferSelect
